module.exports = ".fa-lg {\n  font-size: 1.33333333em;\n  line-height: 1em;\n  vertical-align: -15%;\n  padding: 8px; }\n\ntr.td-data-table-row {\n  height: 120px; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/diagnosticos/diagnosticos.component.scss
// module id = ./src/app/consulta/diagnosticos/diagnosticos.component.scss
// module chunks = main